<template>
  <v-container fluid>
    <v-flex class="text-center">
      <v-row>
        <v-col cols="4">
        </v-col>
        <v-col cols="2">
          <v-autocomplete
              v-model="sheet"
              :items="items"
              item-text="text"
              item-value="value"
              outlined
              dense
              chips
              small-chips
              :label="$t('number_cards_sheet')"
          ></v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-btn
              block
              color="primary"
              @click="generatePDF()"
          >
            {{$t('generate_pdf_printing')}}
          </v-btn>
        </v-col>
        <v-col cols="4">
        </v-col>
      </v-row>
    </v-flex>
    <v-card justify="center">
      <v-card-text justify="center">
        <div>
          <v-layout row wrap class="text-center">
            <v-flex xs6 class="text-center"  v-for="(worker, i) in listPrint" v-bind:key="i">
              <v-avatar
                  class="profile"
                  color="grey"
                  size="100"
              >
                <v-img
                    :src="worker.avatar"
                    v-if="worker.avatar"
                >
                </v-img>
              </v-avatar>
              <br>
              <v-avatar
                  class="profile"
                  tile
                  color="grey"
                  size="100"
              >
                <v-img
                    :src="'https://api.qrserver.com/v1/create-qr-code/?data=' + worker.qr_code + '&ecc=M&margin=20&size=400x400'"
                    v-if="worker.avatar"
                >
                </v-img>
              </v-avatar>
              <h2>
                {{ worker.first_name}}
                {{ worker.last_name}}
              </h2>
              <h2>
                {{$t('direccion')}}:
              </h2>
              <h2>
                {{ worker.address}}
              </h2>
              <h2>
                {{$t('check_in_time')}}: {{ worker.check_in_time}}
              </h2>
              <h2>
                {{$t('check_out_time')}}: {{ worker.check_out_time}}
              </h2>
              <h2>
                {{$t('fecha_inicial')}}: {{ worker.initial_date}}
              </h2>
              <h2>
                {{$t('fecha_expiracion')}}: {{ worker.final_date}}
              </h2>
              <h2>
                {{$t('dias_validos')}}:
                {{ worker.diary.includes('0') === true ? 'L' : ''}}
                {{ worker.diary.includes('1') === true ? 'Ma' : ''}}
                {{ worker.diary.includes('2') === true ? 'Mi' : ''}}
                {{ worker.diary.includes('3') === true ? 'J' : ''}}
                {{ worker.diary.includes('4') === true ? 'V' : ''}}
                {{ worker.diary.includes('5') === true ? 'S' : ''}}
                {{ worker.diary.includes('6') === true ? 'D' : ''}}
              </h2>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
    </v-card>
    <v-flex class="text-center">
      <v-row>
        <v-col cols="4">
        </v-col>
        <v-col cols="2">
          <v-autocomplete
              v-model="sheet"
              :items="items"
              item-text="text"
              item-value="value"
              outlined
              dense
              chips
              small-chips
              :label="$t('number_cards_sheet')"
          ></v-autocomplete>
        </v-col>
        <v-col cols="2">
          <v-btn
              block
              color="primary"
              @click="generatePDF()"
          >
            {{$t('generate_pdf_printing')}}
          </v-btn>
        </v-col>
        <v-col cols="4">
        </v-col>
      </v-row>
    </v-flex>
  </v-container>
</template>

<script>
import JSPDF from 'jspdf'

export default {
  name: 'print',
  created () {
    this.listPrint = localStorage.getItem('listPrint') === null ? [] : JSON.parse(localStorage.getItem('listPrint'))
  },
  data: () => ({
    listPrint: [],
    sheet: 4,
    items: [
      {
        text: '2X2',
        value: 4
      },
      {
        text: '4X3',
        value: 12
      }
    ]
  }),
  methods: {
    leftUp (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 40, 20, 80, 80, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 40, 100, 80, 80, { align: 'center' })
      pdf.text(this.$t('initialDate'), ((pdf.internal.pageSize.width / 10) * 1) + 20, 200, { align: 'center' })
      pdf.text(this.$t('finalDate'), ((pdf.internal.pageSize.width / 10) * 4) - 20, 200, { align: 'center' })
      pdf.text(this.listPrint[index].initial_date, ((pdf.internal.pageSize.width / 10) * 1) + 20, 220, { align: 'center' })
      pdf.text(this.listPrint[index].final_date, ((pdf.internal.pageSize.width / 10) * 4) - 20, 220, { align: 'center' })
      pdf.text(this.$t('check_in_time'), ((pdf.internal.pageSize.width / 10) * 1) + 20, 240, { align: 'center' })
      pdf.text(this.$t('check_out_time'), ((pdf.internal.pageSize.width / 10) * 4) - 20, 240, { align: 'center' })
      pdf.text(this.listPrint[index].check_in_time, ((pdf.internal.pageSize.width / 10) * 1) + 20, 260, { align: 'center' })
      pdf.text(this.listPrint[index].check_out_time, ((pdf.internal.pageSize.width / 10) * 4) - 20, 260, { align: 'center' })
      pdf.text(this.$t('access_days'), ((pdf.internal.pageSize.width / 4) * 1), 280, { align: 'center' })

      pdf.rect(((pdf.internal.pageSize.width / 24) * 3), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 3), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 4), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 4), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 5), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 5), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 6), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 6), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 7), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 7), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 8), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 8), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 9), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 9), 300, 25, 20, 'S')

      pdf.text('Lu', ((pdf.internal.pageSize.width / 24) * 3), 300)
      pdf.text('Ma', ((pdf.internal.pageSize.width / 24) * 4), 300)
      pdf.text('Mi', ((pdf.internal.pageSize.width / 24) * 5), 300)
      pdf.text('Ju', ((pdf.internal.pageSize.width / 24) * 6), 300)
      pdf.text('Vi', ((pdf.internal.pageSize.width / 24) * 7), 300)
      pdf.text('Sa', ((pdf.internal.pageSize.width / 24) * 8), 300)
      pdf.text('Do', ((pdf.internal.pageSize.width / 24) * 9), 300)

      if (this.listPrint[index].diary.includes('0') === true) {
        // Lunes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 3), 320)
      }
      if (this.listPrint[index].diary.includes('1') === true) {
        // Martes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 4), 320)
      }
      if (this.listPrint[index].diary.includes('2') === true) {
        // Miercoles
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 5), 320)
      }
      if (this.listPrint[index].diary.includes('3') === true) {
        // Jueves
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 6), 320)
      }
      if (this.listPrint[index].diary.includes('4') === true) {
        // Viernes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 7), 320)
      }
      if (this.listPrint[index].diary.includes('5') === true) {
        // Sabado
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 8), 320)
      }
      if (this.listPrint[index].diary.includes('6') === true) {
        // Domingo
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 9), 320)
      }
      pdf.text(this.listPrint[index].first_name + ' ' + this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 1), 350, { align: 'center' })
    },
    rightUp (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 40, 20, 80, 80, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 40, 100, 80, 80, { align: 'center' })
      pdf.text(this.$t('initialDate'), ((pdf.internal.pageSize.width / 10) * 6) + 20, 200, { align: 'center' })
      pdf.text(this.$t('finalDate'), ((pdf.internal.pageSize.width / 10) * 9) - 20, 200, { align: 'center' })
      pdf.text(this.listPrint[index].initial_date, ((pdf.internal.pageSize.width / 10) * 6) + 20, 220, { align: 'center' })
      pdf.text(this.listPrint[index].final_date, ((pdf.internal.pageSize.width / 10) * 9) - 20, 220, { align: 'center' })
      pdf.text(this.$t('check_in_time'), ((pdf.internal.pageSize.width / 10) * 6) + 20, 240, { align: 'center' })
      pdf.text(this.$t('check_out_time'), ((pdf.internal.pageSize.width / 10) * 9) - 20, 240, { align: 'center' })
      pdf.text(this.listPrint[index].check_in_time, ((pdf.internal.pageSize.width / 10) * 6) + 20, 260, { align: 'center' })
      pdf.text(this.listPrint[index].check_out_time, ((pdf.internal.pageSize.width / 10) * 9) - 20, 260, { align: 'center' })
      pdf.text(this.$t('access_days'), ((pdf.internal.pageSize.width / 4) * 3), 280, { align: 'center' })

      pdf.rect(((pdf.internal.pageSize.width / 24) * 15), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 15), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 16), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 16), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 17), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 17), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 18), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 18), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 19), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 19), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 20), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 20), 300, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 21), 284, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 21), 300, 25, 20, 'S')

      pdf.text('Lu', ((pdf.internal.pageSize.width / 24) * 15), 300)
      pdf.text('Ma', ((pdf.internal.pageSize.width / 24) * 16), 300)
      pdf.text('Mi', ((pdf.internal.pageSize.width / 24) * 17), 300)
      pdf.text('Ju', ((pdf.internal.pageSize.width / 24) * 18), 300)
      pdf.text('Vi', ((pdf.internal.pageSize.width / 24) * 19), 300)
      pdf.text('Sa', ((pdf.internal.pageSize.width / 24) * 20), 300)
      pdf.text('Do', ((pdf.internal.pageSize.width / 24) * 21), 300)

      if (this.listPrint[index].diary.includes('0') === true) {
        // Lunes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 15), 320)
      }
      if (this.listPrint[index].diary.includes('1') === true) {
        // Martes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 16), 320)
      }
      if (this.listPrint[index].diary.includes('2') === true) {
        // Miercoles
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 17), 320)
      }
      if (this.listPrint[index].diary.includes('3') === true) {
        // Jueves
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 18), 320)
      }
      if (this.listPrint[index].diary.includes('4') === true) {
        // Viernes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 19), 320)
      }
      if (this.listPrint[index].diary.includes('5') === true) {
        // Sabado
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 20), 320)
      }
      if (this.listPrint[index].diary.includes('6') === true) {
        // Domingo
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 21), 320)
      }
      pdf.text(this.listPrint[index].first_name + ' ' + this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 3), 350, { align: 'center' })
    },
    leftDown (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 40, (pdf.internal.pageSize.height / 2) + 20, 80, 80, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 40, 100 + (pdf.internal.pageSize.height / 2) + 20, 80, 80, { align: 'center' })
      pdf.text(this.$t('initialDate'), ((pdf.internal.pageSize.width / 10) * 1) + 20, 200 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('finalDate'), ((pdf.internal.pageSize.width / 10) * 4) - 20, 200 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].initial_date, ((pdf.internal.pageSize.width / 10) * 1) + 20, 220 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].final_date, ((pdf.internal.pageSize.width / 10) * 4) - 20, 220 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('check_in_time'), ((pdf.internal.pageSize.width / 10) * 1) + 20, 240 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('check_out_time'), ((pdf.internal.pageSize.width / 10) * 4) - 20, 240 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].check_in_time, ((pdf.internal.pageSize.width / 10) * 1) + 20, 260 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].check_out_time, ((pdf.internal.pageSize.width / 10) * 4) - 20, 260 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('access_days'), ((pdf.internal.pageSize.width / 4) * 1), 280 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })

      pdf.rect(((pdf.internal.pageSize.width / 24) * 3), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 3), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 4), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 4), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 5), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 5), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 6), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 6), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 7), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 7), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 8), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 8), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 9), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 9), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.text('Lu', ((pdf.internal.pageSize.width / 24) * 3), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Ma', ((pdf.internal.pageSize.width / 24) * 4), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Mi', ((pdf.internal.pageSize.width / 24) * 5), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Ju', ((pdf.internal.pageSize.width / 24) * 6), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Vi', ((pdf.internal.pageSize.width / 24) * 7), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Sa', ((pdf.internal.pageSize.width / 24) * 8), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Do', ((pdf.internal.pageSize.width / 24) * 9), 300 + (pdf.internal.pageSize.height / 2) + 20)

      if (this.listPrint[index].diary.includes('0') === true) {
        // Lunes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 3), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('1') === true) {
        // Martes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 4), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('2') === true) {
        // Miercoles
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 5), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('3') === true) {
        // Jueves
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 6), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('4') === true) {
        // Viernes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 7), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('5') === true) {
        // Sabado
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 8), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('6') === true) {
        // Domingo
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 9), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      pdf.text(this.listPrint[index].first_name + ' ' + this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 1), 350 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
    },
    rightDown (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 40, (pdf.internal.pageSize.height / 2) + 20, 80, 80, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 40, 100 + (pdf.internal.pageSize.height / 2) + 20, 80, 80, { align: 'center' })
      pdf.text(this.$t('initialDate'), ((pdf.internal.pageSize.width / 10) * 6) + 20, 200 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('finalDate'), ((pdf.internal.pageSize.width / 10) * 9) - 20, 200 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].initial_date, ((pdf.internal.pageSize.width / 10) * 6) + 20, 220 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].final_date, ((pdf.internal.pageSize.width / 10) * 9) - 20, 220 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('check_in_time'), ((pdf.internal.pageSize.width / 10) * 6) + 20, 240 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('check_out_time'), ((pdf.internal.pageSize.width / 10) * 9) - 20, 240 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].check_in_time, ((pdf.internal.pageSize.width / 10) * 6) + 20, 260 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.listPrint[index].check_out_time, ((pdf.internal.pageSize.width / 10) * 9) - 20, 260 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
      pdf.text(this.$t('access_days'), ((pdf.internal.pageSize.width / 4) * 3), 280 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })

      pdf.rect(((pdf.internal.pageSize.width / 24) * 15), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 15), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 16), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 16), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 17), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 17), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 18), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 18), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 19), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 19), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 20), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 20), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.rect(((pdf.internal.pageSize.width / 24) * 21), 284 + (pdf.internal.pageSize.height / 2) + 20, 25, 16, 'S')
      pdf.rect(((pdf.internal.pageSize.width / 24) * 21), 300 + (pdf.internal.pageSize.height / 2) + 20, 25, 20, 'S')

      pdf.text('Lu', ((pdf.internal.pageSize.width / 24) * 15), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Ma', ((pdf.internal.pageSize.width / 24) * 16), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Mi', ((pdf.internal.pageSize.width / 24) * 17), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Ju', ((pdf.internal.pageSize.width / 24) * 18), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Vi', ((pdf.internal.pageSize.width / 24) * 19), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Sa', ((pdf.internal.pageSize.width / 24) * 20), 300 + (pdf.internal.pageSize.height / 2) + 20)
      pdf.text('Do', ((pdf.internal.pageSize.width / 24) * 21), 300 + (pdf.internal.pageSize.height / 2) + 20)

      if (this.listPrint[index].diary.includes('0') === true) {
        // Lunes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 15), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('1') === true) {
        // Martes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 16), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('2') === true) {
        // Miercoles
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 17), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('3') === true) {
        // Jueves
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 18), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('4') === true) {
        // Viernes
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 19), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('5') === true) {
        // Sabado
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 20), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      if (this.listPrint[index].diary.includes('6') === true) {
        // Domingo
        pdf.text('X', ((pdf.internal.pageSize.width / 24) * 21), 320 + (pdf.internal.pageSize.height / 2) + 20)
      }
      pdf.text(this.listPrint[index].first_name + ' ' + this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 3), 350 + (pdf.internal.pageSize.height / 2) + 20, { align: 'center' })
    },
    printExternal () {
      let pdf = new JSPDF('portrait', 'pt', 'letter')
      let count = 0
      for (let i = 0; i < this.listPrint.length; i++) {
        count++
        switch (count) {
          case 1:
            pdf.roundedRect(0, 0, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.leftUp(pdf, i)
            break
          case 2:
            pdf.roundedRect(pdf.internal.pageSize.width / 2, 0, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.rightUp(pdf, i)
            break
          case 3:
            pdf.roundedRect(0, pdf.internal.pageSize.height / 2, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.leftDown(pdf, i)
            break
          case 4:
            pdf.roundedRect(pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.rightDown(pdf, i)
            break
        }
        if (count % 4 === 0) {
          count = 0
          pdf.addPage()
        }
      }
      pdf.save('gafete.pdf')
    },
    leftUp2 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 50, 40, 100, 100, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 75, 200, 150, 150, { align: 'center' })
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 4) * 1), 170, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 1), 185, { align: 'center' })
    },
    rightUp2 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 50, 40, 100, 100, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 75, 200, 150, 150, { align: 'center' })
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 4) * 3), 170, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 3), 185, { align: 'center' })
    },
    leftDown2 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 50, (pdf.internal.pageSize.height / 2) + 50, 100, 100, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 1) - 75, 200 + (pdf.internal.pageSize.height / 2), 150, 150, { align: 'center' })
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 4) * 1), 170 + (pdf.internal.pageSize.height / 2), { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 1), 185 + (pdf.internal.pageSize.height / 2), { align: 'center' })
    },
    rightDown2 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 50, (pdf.internal.pageSize.height / 2) + 50, 100, 100, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 4) * 3) - 75, 200 + (pdf.internal.pageSize.height / 2), 150, 150, { align: 'center' })
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 4) * 3), 170 + (pdf.internal.pageSize.height / 2), { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 4) * 3), 185 + (pdf.internal.pageSize.height / 2), { align: 'center' })
    },
    printExternal2 () {
      let pdf = new JSPDF('portrait', 'pt', 'letter')
      let count = 0
      for (let i = 0; i < this.listPrint.length; i++) {
        count++
        switch (count) {
          case 1:
            pdf.roundedRect(0, 0, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.leftUp2(pdf, i)
            break
          case 2:
            pdf.roundedRect(pdf.internal.pageSize.width / 2, 0, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.rightUp2(pdf, i)
            break
          case 3:
            pdf.roundedRect(0, pdf.internal.pageSize.height / 2, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.leftDown2(pdf, i)
            break
          case 4:
            pdf.roundedRect(pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, pdf.internal.pageSize.width / 2, pdf.internal.pageSize.height / 2, 5, 5, 'S')
            this.rightDown2(pdf, i)
            break
        }
        if (count % 4 === 0) {
          count = 0
          pdf.addPage()
        }
      }
      pdf.save('gafete.pdf')
    },
    Up01 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 1) - 25, 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 1) - 50, 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 1), 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 1), 130, { align: 'center' })
    },
    Up02 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 3) - 25, 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 3) - 50, 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 3), 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 3), 130, { align: 'center' })
    },
    Up03 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 5) - 25, 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 5) - 50, 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 5), 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 5), 130, { align: 'center' })
    },
    Up04 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 7) - 25, 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 7) - 50, 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 7), 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 7), 130, { align: 'center' })
    },
    Middle01 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 1) - 25, (pdf.internal.pageSize.height / 3) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 1) - 50, (pdf.internal.pageSize.height / 3) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 1), (pdf.internal.pageSize.height / 3) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 1), (pdf.internal.pageSize.height / 3) + 130, { align: 'center' })
    },
    Middle02 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 3) - 25, (pdf.internal.pageSize.height / 3) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 3) - 50, (pdf.internal.pageSize.height / 3) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 3), (pdf.internal.pageSize.height / 3) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 3), (pdf.internal.pageSize.height / 3) + 130, { align: 'center' })
    },
    Middle03 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 5) - 25, (pdf.internal.pageSize.height / 3) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 5) - 50, (pdf.internal.pageSize.height / 3) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 5), (pdf.internal.pageSize.height / 3) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 5), (pdf.internal.pageSize.height / 3) + 130, { align: 'center' })
    },
    Middle04 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 7) - 25, (pdf.internal.pageSize.height / 3) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 7) - 50, (pdf.internal.pageSize.height / 3) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 7), (pdf.internal.pageSize.height / 3) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 7), (pdf.internal.pageSize.height / 3) + 130, { align: 'center' })
    },
    Down01 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 1) - 25, ((pdf.internal.pageSize.height / 3) * 2) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 1) - 50, ((pdf.internal.pageSize.height / 3) * 2) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 1), ((pdf.internal.pageSize.height / 3) * 2) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 1), ((pdf.internal.pageSize.height / 3) * 2) + 130, { align: 'center' })
    },
    Down02 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 3) - 25, ((pdf.internal.pageSize.height / 3) * 2) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 3) - 50, ((pdf.internal.pageSize.height / 3) * 2) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 3), ((pdf.internal.pageSize.height / 3) * 2) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 3), ((pdf.internal.pageSize.height / 3) * 2) + 130, { align: 'center' })
    },
    Down03 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 5) - 25, ((pdf.internal.pageSize.height / 3) * 2) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 5) - 50, ((pdf.internal.pageSize.height / 3) * 2) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 5), ((pdf.internal.pageSize.height / 3) * 2) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 5), ((pdf.internal.pageSize.height / 3) * 2) + 130, { align: 'center' })
    },
    Down04 (pdf, index) {
      pdf.addImage(this.listPrint[index].avatar, 'WEB', ((pdf.internal.pageSize.width / 8) * 7) - 25, ((pdf.internal.pageSize.height / 3) * 2) + 40, 50, 50, { align: 'center' })
      pdf.addImage(this.listPrint[index].qr_code_base64, 'WEB', ((pdf.internal.pageSize.width / 8) * 7) - 50, ((pdf.internal.pageSize.height / 3) * 2) + 150, 100, 100)
      pdf.text(this.listPrint[index].first_name, ((pdf.internal.pageSize.width / 8) * 7), ((pdf.internal.pageSize.height / 3) * 2) + 120, { align: 'center' })
      pdf.text(this.listPrint[index].last_name, ((pdf.internal.pageSize.width / 8) * 7), ((pdf.internal.pageSize.height / 3) * 2) + 130, { align: 'center' })
    },
    printExternal12 () {
      let pdf = new JSPDF('portrait', 'pt', 'letter')
      pdf.setFontSize(8)
      let count = 0
      for (let i = 0; i < this.listPrint.length; i++) {
        count++
        switch (count) {
          case 1:
            pdf.roundedRect(0, 0, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Up01(pdf, i)
            // this.Middle01(pdf, i)
            // this.Down01(pdf, i)
            break
          case 2:
            pdf.roundedRect(pdf.internal.pageSize.width / 4, 0, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Up02(pdf, i)
            // this.Middle02(pdf, i)
            // this.Down02(pdf, i)
            break
          case 3:
            pdf.roundedRect((pdf.internal.pageSize.width / 4) * 2, 0, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Up03(pdf, i)
            // this.Middle03(pdf, i)
            // this.Down03(pdf, i)
            break
          case 4:
            pdf.roundedRect((pdf.internal.pageSize.width / 4) * 3, 0, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Up04(pdf, i)
            // this.Middle04(pdf, i)
            // this.Down04(pdf, i)
            break
          case 5:
            pdf.roundedRect(0, pdf.internal.pageSize.height / 3, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Middle01(pdf, i)
            break
          case 6:
            pdf.roundedRect(pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Middle02(pdf, i)
            break
          case 7:
            pdf.roundedRect((pdf.internal.pageSize.width / 4) * 2, pdf.internal.pageSize.height / 3, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Middle03(pdf, i)
            break
          case 8:
            pdf.roundedRect((pdf.internal.pageSize.width / 4) * 3, pdf.internal.pageSize.height / 3, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Middle04(pdf, i)
            break
          case 9:
            pdf.roundedRect(0, (pdf.internal.pageSize.height / 3) * 2, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Down01(pdf, i)
            break
          case 10:
            pdf.roundedRect(pdf.internal.pageSize.width / 4, (pdf.internal.pageSize.height / 3) * 2, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Down02(pdf, i)
            break
          case 11:
            pdf.roundedRect((pdf.internal.pageSize.width / 4) * 2, (pdf.internal.pageSize.height / 3) * 2, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Down03(pdf, i)
            break
          case 12:
            pdf.roundedRect((pdf.internal.pageSize.width / 4) * 3, (pdf.internal.pageSize.height / 3) * 2, pdf.internal.pageSize.width / 4, pdf.internal.pageSize.height / 3, 5, 5, 'S')
            this.Down04(pdf, i)
            break
        }
        if (count % 12 === 0) {
          count = 0
          pdf.addPage()
        }
      }
      pdf.save('gafete.pdf')
    },
    generatePDF () {
      if (this.sheet === 4) {
        this.printExternal2()
      }
      if (this.sheet === 12) {
        this.printExternal12()
      }
    }
  }
}
</script>

<style scoped>
    .error {
        font-weight: bold;
        color: red;
    }

    #datas {
        font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
        border-collapse: collapse;
        width: 100%;
    }

    #datas td, #datas th {
        padding: 8px;
    }

    #datas tr:nth-child(even){background-color: #f2f2f2;}

    #datas tr:hover {background-color: #ddd;}

    #datas th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: #2a2738;
        color: white;
    }
    .edge {
        border-radius: 8px;
        border-color: #2a2738 #2a2738 #2a2738 #2a2738;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
